import React, { useCallback } from 'react';
import { Combobox, FormField, FormHelp, Label } from '@zillow/constellation';
import { useField } from 'formik';
import { eUSAState, StatesLabelValueId } from '../../../../ui-toolkit/enums/states';

export const StateFilter: React.FC = () => {
  const [field, meta, helpers] = useField<eUSAState[]>({ name: 'states' });
  const onChange = useCallback(
    (nextValue: any) => {
      helpers.setValue(nextValue);
    },
    [helpers]
  );
  return (
    <FormField
      label={<Label>States</Label>}
      control={
        <Combobox
          value={field.value}
          options={StatesLabelValueId}
          onChange={onChange}
          autoCompleteBehavior="automatic"
          multiple
          showLabelForValue
          limitTagsShown={3}
        />
      }
      error={!!meta.error}
      description={<FormHelp>{meta.error}</FormHelp>}
    />
  );
};
